import { Tag, TagSize } from "@cofano/cck";
import { LabelFragment } from "__generated__/view/labels/graphql/fragments.generated";

const LabelTag = ({ label }: { label: Pick<LabelFragment, "color" | "text"> }) => {
	return (
		<Tag color={label.color} text={label.text} size={TagSize.SMALL} />
	);
};

export default LabelTag;
